export const STAR_ICON_KEY = 'MDP_MetodosDePago_Icono_PagoPreferidoSeleccionado2';

export const TRANSLATION_KEYS = {
  PREFERRED_PAYMENT_SELECTED: {
    key: 'MDP_MetodosDePago_Texto_PagoPreferidoSeleccionado',
    length: 24,
  }
}